<template>
  <div class="supertree-configure-header">
    <span class="supertree-configure-header--title">{{ title }}</span>
    <span class="supertree-configure-header--handler">
      <Button
        type="text"
        size="small"
        class="supertree-configure-header--handler-item"
        @click="onExport"
      >
        <img :src="require('../icon/export.svg')" alt="导出" />
      </Button>
      <Button
        type="text"
        size="small"
        class="supertree-configure-header--handler-item"
      >
        <input type="file" class="upload-input" @change="onImport" />
        <img :src="require('../icon/import.svg')" alt="导入" />
      </Button>
      <Button
        type="text"
        size="small"
        class="supertree-configure-header--handler-item"
        @click="$emit('on-refresh')"
      >
        <img :src="require('../icon/refresh.svg')" alt="刷新" />
      </Button>
    </span>
  </div>
</template>
<script>
export default {
  name: "ConfigureHeader",
  props: {
    title: String,
    value: [],
  },
  data() {
    return {
      importLoading: false,
    };
  },
  methods: {
    onExport() {
      const blob = new Blob([JSON.stringify(this.value, null, 2)], {
        type: "application/json",
      });
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = "字段配置.json";
      a.click();
    },
    onImport(evt) {
      const file = evt.target.files[0];
      if (file.type !== "application/json")
        return this.$Message.error("导入文件格式错误！");
      this.importLoading = true;
      const fileReader = new FileReader();
      fileReader.onload = (evt) => {
        try {
          this.$emit("on-change", JSON.parse(evt.target.result));
        } catch (error) {
          this.$Message.error("无法读取文件内容！");
        }
      };
      fileReader.readAsText(file);
    },
  },
};
</script>
<style lang="stylus" scoped>
.supertree-configure-header
  display flex
  justify-content space-between
  align-items center
  width 100%
  height 40px
  border-bottom 1px solid #ddd
  padding 0 20px
  background #f1f7f7

  &--title
    font-size 14px

  &--handler-item
    margin-left 5px
    line-height 24px
    position relative

    img
      width 13px
      height 13px
      filter drop-shadow(1000px 0 0 #5E5F77)
      transform translate(-1000px)

  .upload-input
    position absolute
    top 0
    left 0
    width 29px
    height 29px
    opacity 0
    z-index 1
</style>
